import VirtualList from 'vue-virtual-scroll-list'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, getLocaleDateString, getLocaleTimeString, moderationColors } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import SingleLink from '@/components/misc/SingleLink'
import row from '@/components/misc/virtualScroll/row'
import { statusColors } from '@/components/services/sendingsModeration/utils'

function renderLabelByPath(h, path) {
  switch (path) {
    case 'pattern':
      return h(
        'div',
        {
          class: `faifs ${Services.sendingsModeration}-dialog__info-label`
        },
        this.getTranslate(`${Services.sendingsModeration}.labels.text`)
      )
    default: {
      return h(
        'div',
        {
          class: `${Services.sendingsModeration}-dialog__info-label`
        },
        this.getTranslate(`${Services.sendingsModeration}.labels.${path}`)
      )
    }
  }
}
function renderSingleLink(h, service, value) {
  return h(
    SingleLink,
    {
      props: {
        service,
        value
      }
    }
  )
}
function renderValueByPath(h, path, value) {
  switch (path) {
    case 'createdAt':
    case 'updatedAt': {
      return [ getLocaleDateString(value), getLocaleTimeString(value) ].join(' ')
    }
    case 'moderation': {
      return h(
        'span',
        {
          class: `${Services.sendingsModeration}-dialog__info-status--${moderationColors[this.data.moderation]}`
        },
        this.getTranslate(`${Services.sendingsModeration}.labels.tasks.moderation.${value}`)
      )
    }
    case 'status': {
      return h(
        'span',
        {
          class: `${Services.sendingsModeration}-dialog__info-status--${statusColors[this.data.status]}`
        },
        this.getTranslate(`${Services.sendingsModeration}.labels.tasks.status.${value}`)
      )
    }
    case 'pattern': {
      return h('pre', { style: 'text-wrap: wrap' }, value)
    }
    case 'OwnerId': {
      return renderSingleLink.call(this, h, 'users', value)
    }
    case 'providerId': {
      return renderSingleLink.call(this, h, 'providers', value)
    }
    default: {
      return value
    }
  }
}
function renderRowByPath(h, path) {
  if (this.data[path]) {
    switch (path) {
      case 'id':
      case 'status':
      case 'moderation':
      case 'pattern':
      case 'OwnerId':
      case 'sender':
      case 'providerId':
      case 'createdAt':
      case 'updatedAt': {
        return h(
          'div',
          {
            class: `${Services.sendingsModeration}-dialog__info-row`
          },
          [
            renderLabelByPath.call(this, h, path),
            h(
              'div',
              {
                class: `${Services.sendingsModeration}-dialog__info-value`
              },
              [ renderValueByPath.call(this, h, path, this.data[path]) ]
            )
          ]
        )
      }
    }
  }
}
function renderInfoRows(h) {
  return Object.keys(this.data).map(path => {
    return renderRowByPath.call(this, h, path)
  })
}
function renderTaskInfo(h) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-dialog__info`
    },
    [ renderInfoRows.call(this, h) ]
  )
}
function renderHint(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.sendingsModeration}.hints.sendings.info`),
        color: Colors.primary
      }
    }
  )
}
function renderSendingsLabel(h) {
  return h(
    'div',
    {
      class: 'subtitle'
    },
    this.getTranslate(`${Services.sendingsModeration}.labels.sendingsList`)
  )
}
function renderSendingsRow(h, sending) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-dialog__body-list__row`,
      on: {
        click: () => {
          this.copyId(sending.sendingId)
        }
      }
    },
    [
      h(
        'div',
        {},
        [ `${sending.sendingId}` ]
      ),
      h(
        'div',
        { class: 'text--grey caption' },
        [ this.getTranslate(`${Services.sendingsModeration}.labels.sendings.sendingId`) ]
      )
    ]
  )
}
function renderSendings(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'fjcc facc pa-3'
      },
      [
        h(
          'g-progress',
          {
            props: {
              indeterminate: true
            }
          }
        )
      ]
    )
  } else if (this.sendings.length) {
    return h(
      VirtualList,
      {
        class: `${Services.sendingsModeration}-dialog__body-list`,
        props: {
          dataKey: 'sendingId',
          dataSources: this.sendings,
          dataComponent: row,
          topThreshold: 1,
          bottomThreshold: 1,
          itemScopedSlots: {
            item: sending => {
              return renderSendingsRow.call(this, h, sending)
            }
          }
        },
        on: {
          totop: () => {
            const loadTop = this.pagination.offset - this.pagination.limit > 0
            if (!this.loading && loadTop) {
              this.pagination.offset -= this.pagination.limit
            }
          },
          tobottom: () => {
            const loadBottom = this.pagination.limit + this.pagination.offset < this.pagination.total
            if (!this.loading && loadBottom) {
              this.pagination.offset += this.pagination.limit
            }
          }
        }
      }
    )
  }

  return h('g-empty')
}

function renderDialogBody(h) {
  return h(
    'div',
    {
      class: `${Services.sendingsModeration}-dialog__body`
    },
    [
      renderTaskInfo.call(this, h),
      renderHint.call(this, h),
      renderSendingsLabel.call(this, h),
      renderSendings.call(this, h)
    ]
  )
}

function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'fjcfe facfe pa-2',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.proxy = false
            }
          }
        }
      )
    ]
  )
}

export default function(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 600
  }

  return h(
    components.dialog,
    {
      class: `${Services.sendingsModeration}-dialog`,
      props: {
        title: this.getTranslate(`${Services.sendingsModeration}.labels.task`),
        value: this.proxy,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
